<template>
    <!-- 强制指定容器尺寸 -->
    <div class="marquee-box" style="width: 100%; height: 30px; border: none;">
      <div class="marquee-inner" :style="scrollStyle">
        <span  :style="{ marginRight: '50px',color: color ? color : '#ff0000'}">{{ text }}</span>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'SureScroll',
    props: {
      text: {
        type: String,
        default: "这次绝对会滚动的文字！"
      },
      color: {
        type: String,
        default: "#ff0000"
      }
    },
    computed: {
      scrollStyle() {
        return {
          animation: 'xscroll 60s linear infinite',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }
      }
    },
    mounted() {
      // 强制重绘hack
      const el = this.$el.querySelector('.marquee-inner')
      el.style.animation = 'none'
      setTimeout(() => el.style.animation = '', 1000)
    }
  }
  </script>
  
  <style scoped>
  .marquee-box {
    overflow: hidden;
    position: relative;
  }
  
  @keyframes xscroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  
  /* 终极兼容写法 */
  .marquee-inner {
    -webkit-animation: xscroll 8s linear infinite;
    -moz-animation: xscroll 8s linear infinite;
    -o-animation: xscroll 8s linear infinite;
    animation: xscroll 8s linear infinite;
  }
  </style>